import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;

  * {
    font-family: 'Montserrat', sans-serif;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 16px;
  }
`

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  background: ${(props) => props.theme.cardBackground};
  padding: 20px 24px;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.cardBorder};
  box-shadow: ${(props) => props.theme.shadow};
  backdrop-filter: blur(10px);

  .title-group {
    display: flex;
    align-items: center;
    gap: 16px;

    .icon-wrapper {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: rgba(166, 193, 11, 0.15);
      border: 1px solid rgba(166, 193, 11, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #a6c10b;
      font-size: 24px;
    }

    h1 {
      font-size: 20px;
      font-weight: 700;
      color: ${(props) => props.theme.titleColor};
      margin: 0;
      letter-spacing: -0.5px;
    }

    p {
      font-size: 13px;
      color: ${(props) => props.theme.textSecondary};
      margin: 4px 0 0 0;
    }
  }

  .actions-group {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => props.theme.name === 'light' ? '#001f5c' : 'rgba(166, 193, 11, 0.12)'};
  border: 1px solid ${props => props.theme.name === 'light' ? '#001f5c' : 'rgba(166, 193, 11, 0.4)'};
  color: ${props => props.theme.name === 'light' ? '#ffffff' : '#a6c10b'};
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${props => props.theme.name === 'light' ? '0 4px 12px rgba(0, 31, 92, 0.15)' : 'none'};

  &:hover {
    background: #a6c10b;
    color: #001f5c;
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(166, 193, 11, 0.25);
  }

  &:active {
    transform: translateY(0);
  }
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`

export const KpiCard = styled.div<{ $highlight?: boolean }>`
  background: ${props => (props.$highlight ? (props.theme.name === 'light' ? 'rgba(166, 193, 11, 0.12)' : 'rgba(166, 193, 11, 0.08)') : props.theme.cardBackground)};
  border: 1px solid ${props => (props.$highlight ? 'rgba(166, 193, 11, 0.4)' : props.theme.cardBorder)};
  box-shadow: ${props => props.theme.name === 'light' ? '0 4px 15px rgba(0, 31, 92, 0.06)' : 'none'};
  border-radius: 14px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  backdrop-filter: blur(10px);
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(166, 193, 11, 0.5);
  }

  .card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    span.label {
      font-size: 12px;
      font-weight: 700;
      color: ${props => props.theme.name === 'light' ? '#475569' : '#94a3b8'};
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .icon-pill {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: ${props => props.theme.name === 'light' ? 'rgba(0, 31, 92, 0.06)' : 'rgba(255, 255, 255, 0.05)'};
      display: flex;
      align-items: center;
      justify-content: center;
      color: #a6c10b;
      font-size: 16px;
    }
  }

  .card-main {
    .value {
      font-size: 24px;
      font-weight: 700;
      color: ${props => props.theme.textPrimary};
      line-height: 1.2;
    }

    .delta {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-top: 6px;
      font-size: 12px;
      font-weight: 600;

      &.positive {
        color: #10b981;
      }

      &.negative {
        color: #ef4444;
      }

      &.neutral {
        color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
      }
    }
  }

  .card-footer {
    margin-top: 12px;
    font-size: 11px;
    color: ${props => props.theme.name === 'light' ? '#64748b' : '#64748b'};
    border-top: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.05)'};
    padding-top: 8px;
  }
`

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};
  padding-bottom: 12px;
  overflow-x: auto;
`

export const TabButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => (props.$active ? 'rgba(166, 193, 11, 0.15)' : props.theme.name === 'light' ? '#ffffff' : 'transparent')};
  border: 1px solid ${props => (props.$active ? 'rgba(166, 193, 11, 0.4)' : props.theme.name === 'light' ? '#cbd5e1' : 'transparent')};
  color: ${props => (props.$active ? '#a6c10b' : props.theme.name === 'light' ? '#475569' : '#94a3b8')};
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: ${props => props.theme.name === 'light' && !props.$active ? '0 2px 6px rgba(0, 31, 92, 0.04)' : 'none'};

  &:hover {
    color: ${props => props.theme.name === 'light' ? '#0f172a' : '#fff'};
    background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.05)'};
  }
`

export const ContentCard = styled.div`
  background: ${props => props.theme.cardBackground};
  border: 1px solid ${props => props.theme.cardBorder};
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: ${props => props.theme.name === 'light' ? '0 4px 15px rgba(0, 31, 92, 0.06)' : 'none'};

  @media (max-width: 768px) {
    padding: 14px;
  }
`

export const Matrix2x2Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const MatrixQuadrantBox = styled.div<{ $quad: 'Q1' | 'Q2' | 'Q3' | 'Q4' }>`
  background: ${props => props.theme.cardBackground};
  border: 1px solid ${props => props.theme.cardBorder};
  border-top: 4px solid ${props => {
    switch (props.$quad) {
      case 'Q1': return '#10b981'
      case 'Q2': return '#3b82f6'
      case 'Q3': return '#f59e0b'
      case 'Q4': return '#ef4444'
    }
  }};
  border-radius: 14px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 320px;
  box-shadow: ${props => props.theme.name === 'light' ? '0 4px 15px rgba(0, 31, 92, 0.06)' : 'none'};
`

export const MatrixQuadrantHeader = styled.div<{ $quad: 'Q1' | 'Q2' | 'Q3' | 'Q4' }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 12px;
  border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.06)'};

  .info {
    h4 {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: ${props => props.theme.titleColor};
      display: flex;
      align-items: center;
      gap: 8px;
    }
    p {
      margin: 4px 0 0 0;
      font-size: 11px;
      color: ${props => props.theme.subtitleColor};
      line-height: 1.3;
    }
  }

  .quad-badge {
    font-size: 10px;
    font-weight: 700;
    padding: 3px 8px;
    border-radius: 6px;
    background: ${props => {
      switch (props.$quad) {
        case 'Q1': return 'rgba(16, 185, 129, 0.2)'
        case 'Q2': return 'rgba(59, 130, 246, 0.2)'
        case 'Q3': return 'rgba(245, 158, 11, 0.2)'
        case 'Q4': return 'rgba(239, 68, 68, 0.2)'
      }
    }};
    color: ${props => {
      switch (props.$quad) {
        case 'Q1': return '#10b981'
        case 'Q2': return '#3b82f6'
        case 'Q3': return '#f59e0b'
        case 'Q4': return '#ef4444'
      }
    }};
    border: 1px solid ${props => {
      switch (props.$quad) {
        case 'Q1': return 'rgba(16, 185, 129, 0.35)'
        case 'Q2': return 'rgba(59, 130, 246, 0.35)'
        case 'Q3': return 'rgba(245, 158, 11, 0.35)'
        case 'Q4': return 'rgba(239, 68, 68, 0.35)'
      }
    }};
    white-space: nowrap;
  }
`

export const MatrixItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 480px;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 4px;
  }
`

export const MatrixItemCard = styled.div<{ $quadColor: string }>`
  background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.03)'};
  border: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.06)'};
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: all 0.2s ease;
  box-shadow: ${props => props.theme.name === 'light' ? '0 2px 6px rgba(0, 31, 92, 0.04)' : 'none'};

  &:hover {
    background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.07)'};
    border-color: ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.15)'};
    transform: translateX(2px);
  }

  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 13px;
      font-weight: 700;
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#fff'};
    }

    .giro-val {
      font-size: 13px;
      font-weight: 700;
      color: ${props => props.$quadColor};
    }
  }

  .meta-row {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
  }

  .progress-bar {
    width: 100%;
    height: 5px;
    background: ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.08)'};
    border-radius: 3px;
    overflow: hidden;
    margin-top: 4px;

    .fill {
      height: 100%;
      border-radius: 3px;
      background: ${props => props.$quadColor};
    }
  }
`

export const QuadrantLegendGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
  margin-top: 16px;
`

export const QuadrantLegendItem = styled.div<{ $quad: 'Q1' | 'Q2' | 'Q3' | 'Q4' }>`
  padding: 12px 14px;
  border-radius: 10px;
  border-left: 4px solid ${props => {
    switch (props.$quad) {
      case 'Q1': return '#10b981'
      case 'Q2': return '#3b82f6'
      case 'Q3': return '#f59e0b'
      case 'Q4': return '#ef4444'
    }
  }};
  background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.02)'};
  border: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'transparent'};
  display: flex;
  flex-direction: column;
  gap: 4px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    strong {
      font-size: 12px;
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#fff'};
    }

    span.quad-pill {
      font-size: 10px;
      font-weight: 700;
      padding: 2px 6px;
      border-radius: 4px;
      background: ${props => {
        switch (props.$quad) {
          case 'Q1': return 'rgba(16, 185, 129, 0.2)'
          case 'Q2': return 'rgba(59, 130, 246, 0.2)'
          case 'Q3': return 'rgba(245, 158, 11, 0.2)'
          case 'Q4': return 'rgba(239, 68, 68, 0.2)'
        }
      }};
      color: ${props => {
        switch (props.$quad) {
          case 'Q1': return '#10b981'
          case 'Q2': return '#3b82f6'
          case 'Q3': return '#f59e0b'
          case 'Q4': return '#ef4444'
        }
      }};
    }
  }

  p.desc {
    font-size: 11px;
    color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
    margin: 0;
    line-height: 1.3;
  }
`

export const QuadrantBadge = styled.span<{ $quad: 'Q1' | 'Q2' | 'Q3' | 'Q4' }>`
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: ${props => {
    switch (props.$quad) {
      case 'Q1': return 'rgba(16, 185, 129, 0.18)'
      case 'Q2': return 'rgba(59, 130, 246, 0.18)'
      case 'Q3': return 'rgba(245, 158, 11, 0.18)'
      case 'Q4': return 'rgba(239, 68, 68, 0.18)'
    }
  }};
  color: ${props => {
    switch (props.$quad) {
      case 'Q1': return '#10b981'
      case 'Q2': return '#60a5fa'
      case 'Q3': return '#fbbf24'
      case 'Q4': return '#f87171'
    }
  }};
  border: 1px solid ${props => {
    switch (props.$quad) {
      case 'Q1': return 'rgba(16, 185, 129, 0.3)'
      case 'Q2': return 'rgba(59, 130, 246, 0.3)'
      case 'Q3': return 'rgba(245, 158, 11, 0.3)'
      case 'Q4': return 'rgba(239, 68, 68, 0.3)'
    }
  }};
`

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${props => props.theme.name === 'light' ? '#0f172a' : '#fff'};
  font-size: 13px;

  thead tr {
    background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.05)'};
  }

  th {
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: ${props => props.theme.name === 'light' ? '#334155' : '#cbd5e1'};
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid ${props => props.theme.name === 'light' ? '#001f5c' : 'rgba(166, 193, 11, 0.4)'};
    white-space: nowrap;

    &.right {
      text-align: right;
    }
    &.center {
      text-align: center;
    }
  }

  td {
    padding: 12px 16px;
    border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.04)'};
    color: ${props => props.theme.name === 'light' ? '#0f172a' : '#cbd5e1'};
    white-space: nowrap;

    &.right {
      text-align: right;
    }
    &.center {
      text-align: center;
    }
  }

  tbody tr.cat-row {
    background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.02)'};
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(166, 193, 11, 0.08)'};
    }
  }

  tbody tr.sub-row {
    background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.01)'};
    font-size: 12px;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.04)'};
    }
  }

  tbody tr.sku-row {
    background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 0, 0, 0.25)'};
    font-size: 12px;
    color: ${props => props.theme.name === 'light' ? '#475569' : '#94a3b8'};

    &:hover {
      background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(0, 0, 0, 0.35)'};
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#fff'};
    }
  }
`

export const FilterBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  .search-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    input {
      background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.05)'};
      border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)'};
      border-radius: 8px;
      padding: 8px 12px 8px 34px;
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#fff'};
      font-size: 13px;
      outline: none;
      width: 260px;
      transition: border-color 0.2s;

      &:focus {
        border-color: #a6c10b;
      }

      &::placeholder {
        color: #64748b;
      }
    }

    .search-icon {
      position: absolute;
      left: 10px;
      color: #64748b;
      font-size: 14px;
    }
  }

  .view-toggle {
    display: flex;
    align-items: center;
    background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.04)'};
    padding: 3px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.06)'};

    button {
      background: transparent;
      border: none;
      color: #94a3b8;
      padding: 6px 14px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;

      &.active {
        background: #a6c10b;
        color: #121214;
      }
    }
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 8, 24, 0.78);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 16px;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`

export const ModalContent = styled.div`
  background: ${props => props.theme.name === 'light' ? '#ffffff' : 'linear-gradient(165deg, #001842 0%, #051636 60%, #030f26 100%)'};
  border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(166, 193, 11, 0.28)'};
  border-radius: 20px;
  width: 100%;
  max-width: 560px;
  box-shadow: ${props => props.theme.name === 'light' ? '0 24px 60px rgba(0, 0, 0, 0.15)' : '0 24px 60px rgba(0, 0, 0, 0.65), 0 0 30px rgba(166, 193, 11, 0.08)'};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes slideUp {
    from { transform: translateY(20px) scale(0.97); opacity: 0; }
    to { transform: translateY(0) scale(1); opacity: 1; }
  }
`

export const ModalHeader = styled.div`
  padding: 22px 24px;
  background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.02)'};
  border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.08)'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  .header-info {
    display: flex;
    align-items: center;
    gap: 14px;

    .icon-badge {
      width: 44px;
      height: 44px;
      border-radius: 12px;
      background: rgba(166, 193, 11, 0.14);
      border: 1px solid rgba(166, 193, 11, 0.35);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #a6c10b;
      font-size: 20px;
      flex-shrink: 0;
    }

    h3 {
      font-size: 17px;
      font-weight: 700;
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
      margin: 0;
      letter-spacing: -0.3px;
    }

    p {
      font-size: 12px;
      color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
      margin: 3px 0 0 0;
    }
  }

  .close-btn {
    background: transparent;
    border: none;
    color: #64748b;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
      background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.08)'};
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
    }
  }
`

export const ModalBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .field-group {
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
      font-size: 12.5px;
      font-weight: 600;
      color: ${props => props.theme.name === 'light' ? '#475569' : '#cbd5e1'};
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    select {
      background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(0, 24, 66, 0.85)'};
      border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.14)'};
      border-radius: 10px;
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
      font-size: 14px;
      padding: 12px 14px;
      outline: none;
      transition: all 0.2s ease;
      cursor: pointer;

      &:focus {
        border-color: #a6c10b;
        box-shadow: 0 0 0 2px rgba(166, 193, 11, 0.2);
      }

      option {
        background: ${props => props.theme.name === 'light' ? '#ffffff' : '#001842'};
        color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
        padding: 8px;
      }
    }
  }

  .info-pill {
    background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.03)'};
    border: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.07)'};
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 12.5px;
    line-height: 1.5;
    color: ${props => props.theme.name === 'light' ? '#475569' : '#94a3b8'};

    strong {
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#e2e8f0'};
    }

    &.nacional {
      border-left: 4px solid #38bdf8;
    }

    &.distribuidor {
      border-left: 4px solid #a6c10b;
    }
  }

  .tabs-preview {
    background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(0, 0, 0, 0.22)'};
    border: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.06)'};
    border-radius: 12px;
    padding: 14px 16px;

    .preview-title {
      font-size: 11px;
      font-weight: 700;
      color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 10px;
    }

    .tabs-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;

      @media (max-width: 480px) {
        grid-template-columns: 1fr;
      }

      .tab-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        color: ${props => props.theme.name === 'light' ? '#334155' : '#cbd5e1'};

        .bullet {
          color: #a6c10b;
          font-size: 13px;
        }
      }
    }
  }
`

export const ModalFooter = styled.div`
  padding: 18px 24px;
  background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(0, 0, 0, 0.25)'};
  border-top: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.08)'};
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .btn-cancel {
    background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.05)'};
    border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)'};
    color: ${props => props.theme.name === 'light' ? '#475569' : '#94a3b8'};
    padding: 10px 20px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.1)'};
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
    }
  }

  .btn-export {
    background: #a6c10b;
    border: none;
    color: #0b192c;
    padding: 10px 22px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      background: #b8d60e;
      transform: translateY(-1px);
      box-shadow: 0 4px 14px rgba(166, 193, 11, 0.35);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .spin {
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  }
`

export const DistributorExpandRow = styled.tr`
  background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(0, 18, 48, 0.85)'} !important;

  td {
    padding: 0 !important;
    border-bottom: 2px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(166, 193, 11, 0.3)'} !important;
  }
`

export const DistributorSubPanel = styled.div`
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: ${props => props.theme.name === 'light' ? '#ffffff' : 'linear-gradient(180deg, rgba(0, 24, 66, 0.7) 0%, rgba(3, 15, 38, 0.95) 100%)'};
  border-left: 4px solid #a6c10b;

  .subpanel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    .dist-title {
      display: flex;
      align-items: center;
      gap: 10px;

      h4 {
        margin: 0;
        font-size: 15px;
        font-weight: 700;
        color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
      }

      .badge {
        font-size: 11px;
        font-weight: 600;
        padding: 3px 10px;
        border-radius: 6px;
        background: rgba(166, 193, 11, 0.15);
        color: #a6c10b;
        border: 1px solid rgba(166, 193, 11, 0.3);
      }
    }

    .subpanel-controls {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;

      .subtab-group {
        display: flex;
        background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.05)'};
        padding: 3px;
        border-radius: 8px;
        border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};

        button {
          background: transparent;
          border: none;
          color: #94a3b8;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s;

          &.active.top {
            background: rgba(74, 222, 128, 0.2);
            color: #16a34a;
            border: 1px solid rgba(74, 222, 128, 0.4);
          }

          &.active.bottom {
            background: rgba(248, 113, 113, 0.2);
            color: #dc2626;
            border: 1px solid rgba(248, 113, 113, 0.4);
          }

          &.active.all {
            background: rgba(166, 193, 11, 0.2);
            color: #65a30d;
            border: 1px solid rgba(166, 193, 11, 0.4);
          }
        }
      }

      .mini-search {
        background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.05)'};
        border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)'};
        border-radius: 8px;
        padding: 6px 12px;
        color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
        font-size: 12px;
        outline: none;
        width: 180px;

        &:focus {
          border-color: #a6c10b;
        }

        &::placeholder {
          color: #64748b;
        }
      }
    }
  }

  .subpanel-kpis {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;

    .sub-kpi-card {
      background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.03)'};
      border: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.06)'};
      border-radius: 10px;
      padding: 10px 14px;
      display: flex;
      flex-direction: column;
      gap: 2px;
      min-width: 150px;

      .kpi-title {
        font-size: 11px;
        color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
        text-transform: uppercase;
      }

      .kpi-val {
        font-size: 15px;
        font-weight: 700;
        color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
      }
    }
  }
`

export const DistSkuTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
  background: ${props => props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 0, 0, 0.25)'};
  border: 1px solid ${props => props.theme.name === 'light' ? '#e2e8f0' : 'transparent'};
  border-radius: 10px;
  overflow: hidden;

  thead tr {
    background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.04)'};
    border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};

    th {
      padding: 10px 14px;
      font-size: 11px;
      font-weight: 600;
      color: ${props => props.theme.name === 'light' ? '#475569' : '#94a3b8'};
      text-transform: uppercase;
      text-align: left;
      white-space: nowrap;

      &.right {
        text-align: right;
      }
      &.center {
        text-align: center;
      }
    }
  }

  tbody tr {
    border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.03)'};
    transition: background 0.15s ease;

    &:hover {
      background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.04)'};
    }

    td {
      padding: 10px 14px;
      white-space: nowrap;
      color: ${props => props.theme.name === 'light' ? '#0f172a' : 'inherit'};

      &.right {
        text-align: right;
      }
      &.center {
        text-align: center;
      }
    }
  }

  .rank-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;

    &.gold {
      background: rgba(234, 179, 8, 0.2);
      color: #b45309;
      border: 1px solid rgba(234, 179, 8, 0.4);
    }
    &.silver {
      background: rgba(148, 163, 184, 0.2);
      color: #475569;
      border: 1px solid rgba(148, 163, 184, 0.4);
    }
    &.bronze {
      background: rgba(217, 119, 6, 0.2);
      color: #c2410c;
      border: 1px solid rgba(217, 119, 6, 0.4);
    }
    &.default {
      background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.05)'};
      color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
    }
    &.warning {
      background: rgba(239, 68, 68, 0.18);
      color: #ef4444;
      border: 1px solid rgba(239, 68, 68, 0.35);
    }
  }

  .status-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;

    &.success {
      background: rgba(74, 222, 128, 0.15);
      color: #16a34a;
      border: 1px solid rgba(74, 222, 128, 0.3);
    }
    &.warning {
      background: rgba(248, 113, 113, 0.15);
      color: #dc2626;
      border: 1px solid rgba(248, 113, 113, 0.3);
    }
    &.neutral {
      background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(148, 163, 184, 0.12)'};
      color: ${props => props.theme.name === 'light' ? '#475569' : '#cbd5e1'};
    }
  }

  .bar-container {
    display: flex;
    align-items: center;
    gap: 8px;

    .bar-bg {
      flex: 1;
      height: 6px;
      background: ${props => props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.08)'};
      border-radius: 3px;
      overflow: hidden;

      .bar-fill {
        height: 100%;
        border-radius: 3px;

        &.green {
          background: #22c55e;
        }
        &.red {
          background: #ef4444;
        }
        &.blue {
          background: #0284c7;
        }
      }
    }

    .bar-label {
      font-size: 11px;
      color: ${props => props.theme.name === 'light' ? '#475569' : '#cbd5e1'};
      min-width: 42px;
      text-align: right;
    }
  }
`

// =============================================================================
// TABULEIRO DE BATALHA NAVAL (GRADE DE POSITIVAÇÃO INTERATIVA)
// =============================================================================

export const NavalGridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const NavalGridControlsBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: ${props => props.theme.name === 'light' ? '#ffffff' : props.theme.cardBackground};
  border: 1px solid ${props => props.theme.cardBorder};
  border-radius: 14px;
  padding: 16px 20px;
  box-shadow: ${props => props.theme.shadow};

  .controls-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px;
  }

  .control-group {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .group-label {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }

  .pills-group {
    display: flex;
    align-items: center;
    background: ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.05)'};
    padding: 3px;
    border-radius: 10px;
    border: 1px solid ${props => props.theme.cardBorder};

    button {
      padding: 6px 14px;
      border-radius: 7px;
      font-size: 12px;
      font-weight: 600;
      border: none;
      background: transparent;
      color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      gap: 6px;

      &:hover:not(.active) {
        color: ${props => props.theme.name === 'light' ? '#0f172a' : '#ffffff'};
      }

      &.active {
        background: #001f5c;
        color: #ffffff;
        box-shadow: 0 2px 6px rgba(0, 31, 92, 0.25);
      }
    }
  }

  .select-filter {
    padding: 7px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid ${props => props.theme.cardBorder};
    background: ${props => props.theme.name === 'light' ? '#ffffff' : '#1e293b'};
    color: ${props => props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};
    outline: none;
    cursor: pointer;
    min-width: 170px;
    transition: border-color 0.2s;

    &:focus {
      border-color: #001f5c;
    }
  }

  .btn-swap-axis {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 14px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    background: ${props => props.theme.name === 'light' ? '#f8fafc' : 'rgba(255, 255, 255, 0.08)'};
    color: ${props => props.theme.name === 'light' ? '#001f5c' : '#93c5fd'};
    border: 1px solid ${props => props.theme.name === 'light' ? '#cbd5e1' : 'rgba(147, 197, 253, 0.3)'};
    transition: all 0.2s ease;

    &:hover {
      background: #001f5c;
      color: #ffffff;
      border-color: #001f5c;
    }
  }

  .btn-apply-filter {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 18px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    background: #001f5c;
    color: #ffffff;
    border: 1px solid #00143d;
    box-shadow: 0 2px 6px rgba(0, 31, 92, 0.25);
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      background: #00143d;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 31, 92, 0.35);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-export-grid {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 14px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    background: #10b981;
    color: #ffffff;
    border: 1px solid #059669;
    transition: all 0.2s ease;

    &:hover {
      background: #059669;
      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    }
  }
`

export const NavalScorecardBar = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;

  .scorecard-item {
    background: ${props => props.theme.name === 'light' ? '#ffffff' : props.theme.cardBackground};
    border: 1px solid ${props => props.theme.cardBorder};
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    .icon-box {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;

      &.emerald {
        background: rgba(16, 185, 129, 0.12);
        color: #10b981;
      }
      &.blue {
        background: rgba(59, 130, 246, 0.12);
        color: #3b82f6;
      }
      &.indigo {
        background: rgba(99, 102, 241, 0.12);
        color: #6366f1;
      }
      &.amber {
        background: rgba(245, 158, 11, 0.12);
        color: #f59e0b;
      }
    }

    .meta {
      display: flex;
      flex-direction: column;

      .label {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
      }

      .value {
        font-size: 18px;
        font-weight: 700;
        color: ${props => props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};
        margin-top: 2px;
      }

      .sub {
        font-size: 11px;
        color: ${props => props.theme.name === 'light' ? '#94a3b8' : '#64748b'};
      }
    }
  }
`

export const NavalGridContainer = styled.div`
  background: ${props => props.theme.name === 'light' ? '#ffffff' : props.theme.cardBackground};
  border: 1px solid ${props => props.theme.cardBorder};
  border-radius: 14px;
  overflow: hidden;
  box-shadow: ${props => props.theme.shadow};
  display: flex;
  flex-direction: column;

  .table-scroll {
    max-height: 640px;
    overflow: auto;
    position: relative;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${props => props.theme.name === 'light' ? '#f1f5f9' : '#0f172a'};
    }
    &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.name === 'light' ? '#cbd5e1' : '#334155'};
      border-radius: 4px;
    }
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 12px;

    thead th {
      position: sticky;
      top: 0;
      z-index: 20;
      background: ${props => props.theme.name === 'light' ? '#001f5c' : '#0f172a'};
      color: #ffffff;
      padding: 10px 12px;
      font-weight: 600;
      font-size: 11px;
      text-align: center;
      border-bottom: 2px solid #a6c10b;
      white-space: nowrap;
      min-width: 110px;

      &.corner-header {
        position: sticky;
        top: 0;
        left: 0;
        z-index: 30;
        min-width: 220px;
        text-align: left;
        background: ${props => props.theme.name === 'light' ? '#00143d' : '#090d16'};
        border-right: 2px solid rgba(255, 255, 255, 0.1);
      }

      &.summary-header {
        position: sticky;
        right: 0;
        z-index: 25;
        background: ${props => props.theme.name === 'light' ? '#00143d' : '#090d16'};
        border-left: 2px solid rgba(255, 255, 255, 0.1);
        min-width: 130px;
      }

      .col-title {
        display: block;
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .col-hit-rate {
        display: inline-block;
        font-size: 10px;
        font-weight: 700;
        color: #a6c10b;
        margin-top: 2px;
      }
    }

    tbody tr {
      transition: background 0.15s ease;

      &:hover {
        background: ${props => props.theme.name === 'light' ? 'rgba(0, 31, 92, 0.03)' : 'rgba(255, 255, 255, 0.03)'};
      }

      td.sticky-row-header {
        position: sticky;
        left: 0;
        z-index: 10;
        background: ${props => props.theme.name === 'light' ? '#f8fafc' : '#1e293b'};
        color: ${props => props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};
        font-weight: 600;
        font-size: 12px;
        padding: 8px 14px;
        border-right: 2px solid ${props => props.theme.cardBorder};
        border-bottom: 1px solid ${props => props.theme.cardBorder};
        white-space: nowrap;
        max-width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;

        .row-meta {
          font-size: 10px;
          color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
          font-weight: normal;
          margin-top: 1px;
        }
      }

      td.cell-slot {
        text-align: center;
        padding: 6px;
        border-bottom: 1px solid ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.05)'};
        border-right: 1px solid ${props => props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.05)'};
      }

      td.sticky-row-summary {
        position: sticky;
        right: 0;
        z-index: 10;
        background: ${props => props.theme.name === 'light' ? '#f8fafc' : '#1e293b'};
        padding: 8px 12px;
        text-align: right;
        font-weight: 700;
        border-left: 2px solid ${props => props.theme.cardBorder};
        border-bottom: 1px solid ${props => props.theme.cardBorder};
        white-space: nowrap;
        font-size: 12px;
        color: #10b981;

        .sub-stat {
          font-size: 10px;
          color: ${props => props.theme.name === 'light' ? '#64748b' : '#94a3b8'};
          font-weight: normal;
        }
      }
    }

    tfoot tr td {
      position: sticky;
      bottom: 0;
      z-index: 20;
      background: ${props => props.theme.name === 'light' ? '#f1f5f9' : '#0f172a'};
      color: ${props => props.theme.name === 'light' ? '#0f172a' : '#f8fafc'};
      font-weight: 700;
      padding: 10px 12px;
      text-align: center;
      border-top: 2px solid #a6c10b;

      &.corner-footer {
        position: sticky;
        left: 0;
        bottom: 0;
        z-index: 30;
        text-align: left;
        background: ${props => props.theme.name === 'light' ? '#e2e8f0' : '#090d16'};
        border-right: 2px solid ${props => props.theme.cardBorder};
      }

      &.summary-footer {
        position: sticky;
        right: 0;
        bottom: 0;
        z-index: 30;
        background: ${props => props.theme.name === 'light' ? '#e2e8f0' : '#090d16'};
        border-left: 2px solid ${props => props.theme.cardBorder};
        color: #10b981;
        font-size: 13px;
      }
    }
  }

  .cell-hit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(16, 185, 129, 0.15);
    color: #10b981;
    border: 1px solid rgba(16, 185, 129, 0.35);
    font-weight: 700;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      background: #10b981;
      color: #ffffff;
      transform: scale(1.06);
      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.4);
    }
  }

  .cell-empty {
    display: inline-block;
    color: ${props => props.theme.name === 'light' ? '#cbd5e1' : '#475569'};
    font-size: 12px;
    font-weight: 600;
    user-select: none;
  }
`


